'use client';

import Icon from './Icon';
import svg from 'sprites/close-modal.svg';

export default function IconCloseModal({
  className = 'w-[14px] h-4 fill-brown'
}: {
  className?: string;
}) {
  return <Icon id={svg.id} className={className} />;
}
